import { Injectable } from '@angular/core';

import { Http, Response, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import { ConfigService } from '../commons/config.service';
import { Tree, Param, KeyValue } from './models';

@Injectable()
export class ConfiguratorApiService {

  constructor(private config: ConfigService,
    private http: Http) {
  }

  getParams(xml: string): Observable<Tree> {
    return this.http.get(`${this.config.apiUrl}/parser/get/${xml}`)
      .map(res => this.mapResponse(res))
      .catch(err => this.handleError(err));
  }

  public getParamValue(parameters: Param[], key: string) {
    if (!parameters) {
      return null;
    }
    return parameters.find(r => r.name === key);
  }

  load(
    model: string,
    oldParams: Param[]): Observable<Tree> {
    return this.http.post(this.config.apiUrl + '/parser/load', {
      model: model,
      oldParams: oldParams ? oldParams.map(p => { return { key: p.name, value: p.selectedValue }; }) : null,
      headers: this.getHeaders()
    }).map(res => this.mapResponse(res))
      .catch(err => this.handleError(err));
  }

  update(
    model: string,
    oldParams: Param[],
    name: string,
    value: string,
    stayInPackage: boolean): Observable<Tree> {
    ////console.log(this.config.apiUrl + '/parser/update - ' + model);

    return this.http.post(this.config.apiUrl + '/parser/update', {
      model: model,
      oldParams: oldParams.map(p => { return { key: p.name, value: p.selectedValue }; }),
      newParam: { key: name, value: value },
      stayInPackage: stayInPackage,
      headers: this.getHeaders()
    }).map(res => this.mapResponse(res))
      .catch(err => this.handleError(err));
  }

  multiupdate(
    model: string,
    oldParams: Param[],
    newParams: KeyValue[],
    stayInPackage: boolean): Observable<Tree> {
    ////console.log(this.config.apiUrl + '/parser/multiupdate - ' + model);

    return this.http.post(this.config.apiUrl + '/parser/multiupdate', {
      model: model,
      oldParams: oldParams.map(p => { return { key: p.name, value: p.selectedValue }; }),
      newParams: newParams,
      stayInPackage: stayInPackage,
      headers: this.getHeaders()
    }).map(res => this.mapResponse(res))
      .catch(err => this.handleError(err));
  }

  private getHeaders() {
    let headers = new Headers();
    headers.append('Accept', 'application/json');
    return headers;
  }

  private mapResponse(res: Response) {
    if (!res.ok) {
      this.handleError(res);
    } else {
      return res.json();
    }
  }

  private handleError(error: any) {
    let errMsg;

    if (!!error._body) {
      let errJson = JSON.parse(error._body);
      errMsg = (errJson.ExceptionMessage) ? errJson.ExceptionMessage : error._body;
    } else {
      errMsg = (error.message) ? error.message :
        error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    }

    console.error(errMsg); // log to console instead
    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/commons/configurator-api.service.ts